import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'react-emotion';
import plateBg from '../assets/img/jieqi_geren_icon.png';

const Plate = styled.div`
  width: 70px;
  height: 70px;
  background: url("${plateBg}");
  background-size: 100%;
  padding-top: 20px;
`;

const Jieqi = styled.div`
  font-size: 23px;
  color: white;
  text-align: center;
  line-height: 1;
  font-weight: 500;
`;

const Day = styled.div`
  font-size: 15px;
  line-height: 1;
  text-align: center;
  margin-top: 5px;
  color: white;
`;

class JieqiPlate extends Component {
  render() {
    const { jieqi } = this.props;
    const name = jieqi.substring(0, 2);
    const day = jieqi.length > 2 ? jieqi.substring(2) : null;
    return (
      <Plate>
        <Jieqi>{name}</Jieqi>
        {day ? <Day>{day}</Day> : null}
      </Plate>
    );
  }
}

JieqiPlate.propTypes = {
  jieqi: PropTypes.string.isRequired,
};
JieqiPlate.defaultProps = {};

export default JieqiPlate;



// WEBPACK FOOTER //
// ./src/components/jieqi-plate.jsx